<template>
  <div class="login">
    <h1>1 in 1000 Remote Talent</h1>
    <h2 class="mb-10">Client Portal</h2>
    <p>
      <v-btn color="white" class="elevation-1" @click="socialLogin">
        <img class="g-logo" src="../assets/google-logo.png">
        Sign in with Google
      </v-btn>
    </p>
  </div>
</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import 'firebase/database'

  export default {
    name: 'Login',
    methods: {
      socialLogin() {
        const provider = new firebase.auth.GoogleAuthProvider()

        firebase.auth().signInWithPopup(provider)
        .then(() => {
          const user = firebase.auth().currentUser
          firebase.database().ref('users/' + user.uid).update({
            uid: user.uid,
            displayName: user.displayName,
            email: user.email,
            photoURL : user.photoURL,
          }, err => {
            if (err) {
              alert(err.message)
            } else {
              this.$router.push('/profile')
            }
          })
        }).catch((err) => {
          alert(err.message)
        })
      }
    }
  }
</script>

<style scoped>  
  .login {
    margin: 5rem 0;
  }
  .g-logo {
    max-width: 40px;
    margin-left: -16px;
  }
</style>